// extracted by mini-css-extract-plugin
module.exports = {"empty-icon":"empty-icon___Qbjr-","emptyIcon":"empty-icon___Qbjr-"};